import { useCallback } from 'react';

import { onContextMenuCopyButtonClicked } from '../../../common/utils/events/context-menu-copy-button-clicked';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';

/**
 * @returns a callback to fire an event when the result
 * context menu copy button is clicked by the user.
 */
export const useFireContextMenuCopyButtonClicked: () => () => void = () => {
	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();

	return useCallback(() => {
		fireAnalyticsEvent(
			onContextMenuCopyButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...getExtensionData(commonAttributes.isCQL),
				},
				nonPrivacySafeAttributes,
			}),
		);
	}, [fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes]);
};
